const notFoundDefaults = {
  notFound: [{
    title: '',
    uri: '',
    textBlock: '',
  }],
}

export default notFoundDefaults
